@if (!networkStatus.isOnline()) {
  <div class="offline-banner" role="status" aria-live="polite">
    <mat-icon>cloud_off</mat-icon>
    <span>You are offline — some features may be unavailable until your connection returns.</span>
  </div>
}
